import { CSSProperties } from 'react'
import AlarmSituationsDataTypeDropdownStatusConstants from './AlarmSituationsDataTypeDropdown.constans.ts'
import { IAlarmSituation } from '../../alarmSituations.types.ts'
import DropdownInput from '@/shared/Inputs/DropdownInput'

interface IProps {
  value: IAlarmSituation['level']
  name: string
  onChange: (val: IAlarmSituation['level'], name: string) => void
  title?: string
  wrapperStyle?: CSSProperties
}

const AlarmSituationsDataTypeDropdown = (props: IProps) => {
  return (
    <DropdownInput
      name={props.name}
      wrapperStyle={props.wrapperStyle}
      onSelect={props.onChange}
      options={AlarmSituationsDataTypeDropdownStatusConstants.fieldTypeOptions as any}
      selectedOption={props.value as any}
      title={props.title || 'Тип'}
    />
  )
}

export default AlarmSituationsDataTypeDropdown
